const state = {
  changeTab: '0', //   轮转教材教材库tab切换
  changeCommenTab: '0' //   通用教材教材库tab切换
}

const mutations = {
  changeRotateBooktab (state, v) {
    state.changeTab = v;
  },
  changeCommenBooktab (state, v) {
    state.changeCommenTab = v;
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/rotate.js